import { HttpClient } from "@angular/common/http";
import { Injectable } from "@angular/core";
import { ApiService } from "./api.service";
import { I18nService } from "./i18n.service";
import { Observable } from "rxjs";
import { ApiResponse } from "../models/api-response";
import { EventPackageGroup } from "../models/event/event-package-group";
import { EventPackage } from "../models/event/event-package";
import { EventPackageItem } from "../models/event/event-package-item";
import {ChannelService} from "@biletix/core/services/channel.service";

@Injectable()
export class EventPackageGroupService {

    private eventBasePath: string = "/api/v1/eventPackage";

    constructor(private http: HttpClient,
        private apiService: ApiService,
        private i18n: I18nService,
                private channelService: ChannelService
    ) {

    }


    getEventPackageGroupById(eventPackageGroupId: number): Observable<ApiResponse<EventPackageGroup>>{
        let channel = this.channelService.getChannel();
        let lang = this.i18n.currentLang;
        return this.http//
            .get<ApiResponse<EventPackageGroup>>(`${this.apiService.getCrmApiHost()}${this.eventBasePath}/getEventPackageGroupById/${eventPackageGroupId}/${channel}/${lang}`);
    }

    getEventPackageDetailById(eventPackageId: number): Observable<ApiResponse<EventPackage>>{
        let channel = this.channelService.getChannel();
        let lang = this.i18n.currentLang;
        return this.http//
            .get<ApiResponse<EventPackage>>(`${this.apiService.getCrmApiHost()}${this.eventBasePath}/getEventPackageDetailById/${eventPackageId}/${channel}/${lang}`);
    }

    getEventPackageItemListBySubCategoryId(subCategoryId: number): Observable<EventPackageItem[]>{
        let channel = this.channelService.getChannel();
        let lang = this.i18n.currentLang;
        return this.http//
            .get<EventPackageItem[]>(`${this.apiService.getCrmApiHost()}${this.eventBasePath}/getEventPackageItemListBySubCategoryId/${subCategoryId}/${channel}/${lang}`);
    }

}
